module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@2x-a460f6c04bd9d4e43aca2c02001e835b.png";